<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">会员特权管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>会员类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>版本状态：</label>
          <el-select v-model="versionState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in versionStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>特权名称：</label>
          <el-input type="search" placeholder="请输入内容" v-model="searchValue" style="width: 16em;">
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
<!--          <el-button type="primary" @click="editPrivilegeDialog(-1)">创建</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="" label="特权图标" v-if="checkColList.indexOf('特权图标') > -1">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column property="title" label="特权名称" v-if="checkColList.indexOf('特权名称') > -1"></el-table-column>
          <el-table-column property="description" label="弹窗文案" v-if="checkColList.indexOf('弹窗文案') > -1"></el-table-column>
          <el-table-column property="" label="会员类型" v-if="checkColList.indexOf('会员类型') > -1">
            <template #default="scope">
              {{scope.row.type == 1?'VIP':scope.row.type == 2?'SVIP':''}}
            </template>
          </el-table-column>
          <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state == 0?'待上架':scope.row.state == 1?'已上架':scope.row.state == 2?'已下架':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="版本状态" v-if="checkColList.indexOf('版本状态') > -1" >
            <template #default="scope">
              <span>{{scope.row.versionState == 0?'全部':scope.row.versionState == 1?'旧版':scope.row.versionState == 2?'新版':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editPrivilegeDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 1)">上架</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="danger" v-if="scope.row.state == 1" @click="updateState(scope.$index, scope.row, 2)">下架</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getVipPrivilegePageList, updateVipPrivilegeState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import PrivilegeDialog from "@/views/vip/components/PrivilegeDialog";

export default {
  name: "GiftManage",
  components: { BtnGroup },
  data() {
    return {

      typeArray: [
        {label: '不限', value: -1},
        {label: 'VIP', value: 1},
        {label: 'SVIP', value: 2},
      ],
      type: -1,


      stateArray: [
        {label: '不限', value: -1},
        {label: '已上架', value: 1},
        {label: '已下架', value: 2},
      ],
      state: -1,

      versionStateArray: [
        {label: '不限', value: -1},
        {label: '旧版', value: 1},
        {label: '新版', value: 2},
      ],
      versionState: -1,

      searchValue: '',

      //刷新组
      colList: ['特权图标', '特权名称', '弹窗文案', '会员类型', '排序', '状态', '版本状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,
      switchLoading: false,
    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.type = -1;
      this.state = -1;
      this.versionState = -1;
      this.searchValue = '';
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['type'] = this.type;
      param['state'] = this.state;
      param['searchValue'] = this.searchValue;
      param['versionState'] = this.versionState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getVipPrivilegePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editPrivilegeDialog(idx, row) {
      let _title = '';
      let privilegeForm = {}
      if (idx > -1) {
        _title = '编辑特权'
        privilegeForm = Object.assign({}, row);
      }else {
        _title = '创建特权'
      }
      Dialog.open({
        title: _title,
        component: PrivilegeDialog,
        data: {
          privilegeForm: privilegeForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateVipPrivilegeState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
